import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import RecoverPassword from './components/RecoverPassword';
import ResetPassword from './components/ResetPassword';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Orders from './pages/Orders/Orders';
import UserRegistration from './pages/Users/UserRegistration';
import MaterialRegistration from './pages/Materials/MaterialRegistration';
import LampadaRegistration from './pages/Lampadas/LampadaRegistration';
import RefletorRegistration from './pages/Refletores/RefletorRegistration';
import BairroRegistration from './pages/Bairros/BairroRegistration';
import ActivityLogs from './pages/ActivityLogs/ActivityLogs';
import Sobre from './pages/Sobre/Sobre';
import Heatmap from './pages/Heatmap/Heatmap';
import Relatorios from './pages/Relatorios/Relatorios';
import ProtectedRoute from './components/ProtectedRoute';
import { UserRole } from './types/auth';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/recover-password" element={<RecoverPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole={[UserRole.MASTER, UserRole.ADMIN, UserRole.TECNICO]}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route
              path="users"
              element={
                <ProtectedRoute requiredRole={UserRole.MASTER}>
                  <UserRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="materials"
              element={
                <ProtectedRoute requiredRole={[UserRole.MASTER, UserRole.ADMIN]}>
                  <MaterialRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="lampadas"
              element={
                <ProtectedRoute requiredRole={[UserRole.MASTER, UserRole.ADMIN]}>
                  <LampadaRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="refletores"
              element={
                <ProtectedRoute requiredRole={[UserRole.MASTER, UserRole.ADMIN]}>
                  <RefletorRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="bairros"
              element={
                <ProtectedRoute requiredRole={[UserRole.MASTER, UserRole.ADMIN]}>
                  <BairroRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="logs"
              element={
                <ProtectedRoute requiredRole={UserRole.MASTER}>
                  <ActivityLogs />
                </ProtectedRoute>
              }
            />
            <Route path="mapa-calor" element={<Heatmap />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="sobre" element={<Sobre />} />
          </Route>
          <Route
            path="/unauthorized"
            element={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  flexDirection: 'column',
                }}
              >
                <h2>Acesso Negado</h2>
                <p>Você não tem permissão para acessar esta página.</p>
              </div>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
